package com.appsyde.shared.modules.account.domain.usecase

import com.appsyde.shared.modules.account.domain.model.Account
import com.appsyde.shared.modules.account.domain.repository.AccountRepository

class GetAccountUseCase(
    private val accountRepository: AccountRepository
) {
    suspend operator fun invoke(): Account? = accountRepository.getAccount()
}
